import { isFilled } from "@prismicio/client";
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";
import { Variation } from "@/script/constant";


const PropertyCard = ({ item, variation = Variation.DISPONIBLE }) => {
  const roomNumbers = item.property?.data?.room_numbers;
  const type = item.property?.type;
  const price = item.property?.data?.price;
  const state = item.property?.data?.state;
  const hasRoomNumbers = typeof roomNumbers === "string" && roomNumbers.trim() !== "";
  const hasPrice = typeof price === "number" && Number.isFinite(price);
  const normalizedState = typeof state === "string" ? state.trim().toLowerCase() : "";
  const stateLabel = normalizedState === "vendu" ? "Vendu" : "En vente";
  const stageLabel = {
    "sous offre": "Sous offre",
    "sous compromis": "Sous compromis",
  }[normalizedState] || "";
  const normalizedRentalState =
    typeof state === "string"
      ? state
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .trim()
      : "";
  const isRental = type === "property_rental";
  const isRented = isRental && normalizedRentalState === "loue";
  const rentalTagClass = isRented ? "tag-terracota-100" : "tag-terracota-400";
  const roomUnitLabel = roomNumbers === "1" ? "pièce" : "pièces";
  const formattedPrice = hasPrice
    ? new Intl.NumberFormat("fr-FR").format(price)
    : "";

  return (
    <div className="h-full group">
      {isFilled.link(item.property) && (
        <PrismicLink field={item.property} className="relative flex flex-col h-full">
          <div className="absolute top-4 left-4 flex gap-2 z-20">
            <p className={`body-m text-tag tag ${isRental ? rentalTagClass : "tag-terracota-100"}`}>{isRental ? item.property?.data?.state : stateLabel}</p>
            {item.property?.data?.is_exclusivity === true && (
              <p className="body-m text-tag tag tag-terracota-400">En exclusivité</p>
            )}
          </div>
          {isFilled.image(item.property?.data?.pictures?.[0]?.picture) && (
            <div className="overflow-hidden rounded-tl-[100px] rounded-tr-2xl">
              <PrismicImage className={`group-hover:scale-120 w-full ${variation === Variation.DISPONIBLE ? "h-64" : "h-52 grayscale"} object-cover rounded-tl-[100px] rounded-tr-2xl transition-transform duration-300`}
                field={{
                  ...item.property.data.pictures[0].picture,
                  alt: item.property.data.pictures[0].picture.alt || "Image d'illustration",
                }}
              />
            </div>
          )}

          <div className={`${variation === Variation.DISPONIBLE ? "bg-bleu-950 text-bleu-50" : "bg-terracota-100 text-bleu-950"} justify-between rounded-b-2xl p-4 flex flex-col gap-1 flex-1`}>
            <div className="flex flex-col gap-1">
              {isFilled.richText(item.property?.data?.title) && (
                <PrismicRichText
                  field={item.property.data.title}
                  components={{
                    heading1: ({ children }) => <h3 className="body-m">{children}</h3>,
                  }}
                />
              )}
              <div className="flex gap-1 body-s">
                <p className="body-s">
                  {isFilled.keyText(item.property?.data?.district) && <span>{item.property.data.district},</span>}
                  {isFilled.keyText(item.property?.data?.city) && <span className="ml-1">{item.property.data.city} | </span>}
                  {hasRoomNumbers && (
                    <span>{roomNumbers} {roomUnitLabel} | </span>
                  )}
                  {isFilled.keyText(item.property?.data?.surface) && <span>{item.property.data.surface} m²</span>}
                </p>
              </div>
            </div>
            <div className="flex gap-4 justify-between mt-2">
              {hasPrice && <p className={`body-m font-bold ${variation === Variation.NOT_DISPONIBLE ? "text-bleu-700" : "text-bleu-300"}`}>{formattedPrice} €{type === "property_rental" ? "/mois" : ""}</p>}
              {stageLabel && <p className="body-s text-tag tag tag-bleu-300">{stageLabel}</p>}
            </div>
          </div>
        </PrismicLink>
      )
      }
    </div >
  );
};

export default PropertyCard;
